<template>
  <v-container fluid class="approvals-revamp approvals-revamp--modern oms-list-page oms-list-page--approvals">
    <v-layout class="errorbox" v-if="noTrue">
      <v-flex
        >Seems like you don't have any permissions. Please contact
        administrator</v-flex
      >
    </v-layout>
    <v-card raised v-if="!noTrue" class="approvals-panel oms-list-panel">
      <loading :active.sync="loading" />
      <section class="approvals-page-heading">
        <div>
          <span>Approvals</span>
          <h1>{{ currentTab == "sales" ? "Sales Approval" : "Job Approval" }}</h1>
        </div>
      </section>
      <section class="approvals-nav-grid oms-list-nav">
        <div
          class="segmented-control approvals-tabs"
          aria-label="Approvals section"
          role="tablist"
        >
          <button
            type="button"
            class="segmented-control__item"
            :class="{ 'segmented-control__item--active': TabStatus == 'job' }"
            role="tab"
            :aria-selected="TabStatus == 'job' ? 'true' : 'false'"
            v-permissions="'job-approval'"
            @click="checkJob('job')"
          >
            <span class="segmented-control__label">JOBS</span>
            <span v-if="newJob" class="segmented-control__badge">{{ newJob }}</span>
          </button>
          <button
            type="button"
            class="segmented-control__item"
            :class="{ 'segmented-control__item--active': TabStatus == 'sales' }"
            role="tab"
            :aria-selected="TabStatus == 'sales' ? 'true' : 'false'"
            v-permissions="'sales-approval'"
            @click="checkSales('sales')"
          >
            <span class="segmented-control__label">SALES</span>
            <span v-if="newInquiry" class="segmented-control__badge">{{ newInquiry }}</span>
          </button>
        </div>
      </section>

      <CustomFilter
        v-on:customer-search="searchText"
        v-on:date-Filter="dateFilter"
        v-on:daterangenew-cust="dateRangenew"
        v-on:customer-reset="resetCustomer"
      />

      <approvalsList
        :tabFilter="currentTab"
        :searchText="search"
        :dateRangenew="date2"
        :dateFilter="dateRange"
        :reset="reset"
        :loader="loading"
        v-on:on-block="refreshActivity"
        v-on:on-load="startLoad"
        v-on:off-load="stopLoad"
        :updateList="updateTable"
      />
    </v-card>
  </v-container>
</template>

<script>
import { StorageKeys } from "../../constants/constants";
import { EventBus } from "../../event-bus.js";
import Loading from "vue-loading-overlay";
import Swal from "sweetalert2";
import approvalsList from "./approvalsList";
import CustomFilter from "./CustomFilter";
import checkPermissionsMixin from "@/mixins/checkPermissionsMixin";
import moment from "moment";
export default {
  mixins: [checkPermissionsMixin],
  created() {
    this.$eventBus.$on("job-approval-notification", (value) => {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        let workingCountry = [];
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            workingCountry.push(key.value);
          }
        });
        this.workingCountry = JSON.stringify(workingCountry);
      }
      if (this.workingCountry.includes(value)) {
        this.currentTab = "job";
        this.TabStatus = "job";
        this.newJob = this.newJob + 1;
        this.updateTable = this.updateTable + 1;
      }
    });
    this.$eventBus.$on("sales-approval-notification", (value) => {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        let workingCountry = [];
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            workingCountry.push(key.value);
          }
        });
        this.workingCountry = JSON.stringify(workingCountry);
      }
      if (this.workingCountry.includes(value)) {
        this.newInquiry = this.newInquiry + 1;
        this.updateTable = this.updateTable + 1;
        this.currentTab = "sales";
        this.TabStatus = "sales";
      }
    });

    let userPermissions = JSON.parse(
      localStorage.getItem("permissions")
    ).permissions;
    userPermissions.filter((x) => {
      if (x.operationName == "job-approval") {
        this.currentTab = "job";
        this.TabStatus = "job";
      }
    });
    this.$eventBus.$on("on-load", () => {
      this.loading = true;
    });

    this.$eventBus.$on("off-load", () => {
      this.loading = false;
    });

    if (localStorage.getItem("workingCountries") !== null) {
    }
    EventBus.$on("countryChanged", (val) => {
      this.newInquiry = 0;
      this.newJob = 0;
      this.selectedCountry = val.value;
    });
    if (this.$route.query && this.$route.query.type) {
      if (this.$route.query.type === "job") {
        this.currentTab = "job";
        this.TabStatus = "job";
      } else if (this.$route.query.type === "sales") {
        this.currentTab = "sales";
        this.TabStatus = "sales";
      } else {
        this.currentTab = "sales";
        this.TabStatus = "sales";
      }
    }
    if (this.$route.query && this.$route.query.workingCountry) {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.workingCountry = key.value;
          }
        });
      }

      let key = this.$route.query.workingCountry;
      EventBus.$emit("setCountriesfromUrl", key);
      this.workingCountries.forEach((element, index) => {
        if (element.value === key) {
          element.isSelected = true;
          this.newInquiry = 0;
          this.newJob = 0;
        } else element.isSelected = false;
      });
      localStorage.setItem(
        "workingCountries",
        JSON.stringify(this.workingCountries)
      );
    }
  },

  components: {
    approvalsList,
    CustomFilter,
    Loading,
  },
  data: () => ({
    operationName: "",
    showScreen: true,
    search: "",
    date2: null,
    noTrue: false,
    dateRange: { startDate: "", endDate: "" },
    reset: false,
    newJob: 0,
    newInquiry: 0,
    active: "0",
    dialog: false,
    loading: true,
    selectedCountry: null,
    currentTab: "sales",
    TabStatus: "sales",
    updateTable: 0,
  }),
  methods: {
    async checkJob(section) {
      this.newJob = 0;

      this.operationName = "job-approval";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.viewTab(section);
      } else {
        return;
      }
    },
    async checkSales(section) {
      this.newInquiry = 0;
      this.operationName = "sales-approval";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.viewTab(section);
      } else {
        return;
      }
    },

    refreshActivity() {
      this.reset = true;
    },
    startLoad() {
      this.loading = true;
    },

    stopLoad() {
      this.loading = false;
    },
    resetCustomer(event) {
      this.reset = true;
      this.search = "";
      this.date2 = null;
    },
    dateRangenew(event) {
      this.date2 = event;
      this.reset = false;
    },

    searchText(event) {
      this.search = event;
      this.reset = false;
    },
    dateFilter(event) {
      this.dateRange = event;

      this.reset = false;
    },
    viewTab(flag) {
      if (flag == "job") {
        this.$router.replace({ name: "Approvals", query: { type: "job" } });
      } else {
        this.$router.replace({ name: "Approvals", query: { type: "sales" } });
      }
      this.currentTab = flag;
      this.TabStatus = flag;
    },
  },
  watch: {
    "$route.query"() {
      if (this.$route.query && this.$route.query.type) {
        if (this.$route.query.type === "job") {
          this.currentTab = "job";
          this.TabStatus = "job";
        } else if (this.$route.query.type === "sales") {
          this.currentTab = "sales";
          this.TabStatus = "sales";
        } else {
          this.currentTab = "sales";
          this.TabStatus = "sales";
        }
      }
    },
  },
};
</script>

<style>
.daterangepicker.openscenter[data-v-267f4ee2] {
  position: absolute;
  top: 35px;
  left: 80%;
}
.reportrange-text[data-v-267f4ee2] {
  background: #fff;
  cursor: pointer;
  position: absolute;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #ccc;
  padding: 5px 10px;
  width: 250px;
}

.drp-calendar {
  margin-right: 80px !important;
}

.daterangepicker.openscenter[data-v-267f4ee2] {
  right: auto;
  left: 62%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.errorbox {
  padding: 20px;
  text-align: center;
  color: red !important;
  font-size: 20px;
  padding: 10px 10px 10px 10px !important;
}

.approvals-revamp {
  --approvals-bg: #f6f5f2;
  --approvals-panel: #ffffff;
  --approvals-ink: #3a382f;
  --approvals-muted: #74716a;
  --approvals-primary: #ea7a1c;
  --approvals-primary-dark: #d96a10;
  --approvals-primary-soft: #fdf0e4;
  --approvals-border: #e4e1d9;
  --approvals-shadow: 0 1.125rem 2.8125rem rgba(26, 25, 22, 0.08);
  background: var(--approvals-bg);
  min-height: calc(100vh - 3.375rem);
  padding: 0.25rem !important;
}

.approvals-panel {
  background: var(--approvals-panel) !important;
  border: 0 !important;
  border-radius: 0.5rem !important;
  box-shadow: var(--approvals-shadow) !important;
  overflow: hidden;
}

.approvals-page-heading {
  align-items: center;
  background: #ffffff;
  border-bottom: 0.0625rem solid #f0eee8;
  display: flex;
  justify-content: space-between;
  padding: 1rem var(--oms-list-section-x, 1.875rem) 0.75rem;
}

.approvals-page-heading span {
  color: var(--approvals-primary-dark);
  display: block;
  font-size: 0.6875rem;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.2;
  text-transform: uppercase;
}

.approvals-page-heading h1 {
  color: #0f172a;
  font-size: 1.25rem;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 0.25rem 0 0;
}

.approvals-nav-grid {
  align-items: center;
  background: #ffffff;
  border-bottom: 0.0625rem solid #f0eee8;
  display: flex;
  justify-content: center;
  padding: var(--oms-list-section-y, 0.75rem) var(--oms-list-section-x, 1.875rem);
}

.approvals-tabs {
  background: #f4f3ee !important;
  border: 0.0625rem solid var(--approvals-border) !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  display: flex !important;
  gap: 0.375rem;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.3125rem !important;
  width: fit-content;
}

.approvals-tabs .segmented-control__item {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0.4375rem;
  color: var(--approvals-muted);
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 800;
  gap: 0.375rem;
  justify-content: center;
  letter-spacing: 0;
  min-height: 2rem;
  min-width: 8.75rem;
  outline: none;
  padding: 0.4375rem 1rem;
  white-space: nowrap;
}

.approvals-tabs .segmented-control__item--active {
  background: #ffffff;
  box-shadow: 0 0.3125rem 1rem rgba(26, 25, 22, 0.08);
  color: var(--approvals-primary-dark);
}

.approvals-tabs .segmented-control__badge {
  align-items: center;
  background: var(--approvals-primary);
  border-radius: 999rem;
  color: #ffffff;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 900;
  justify-content: center;
  line-height: 1;
  min-height: 1rem;
  min-width: 1rem;
  padding: 0.125rem 0.3125rem;
}

@media (max-width: 47.5rem) {
  .approvals-tabs {
    gap: 0.75rem;
    width: 100%;
  }

  .approvals-tabs .segmented-control__item {
    flex: 1 1 0;
    min-width: 0;
  }
}
</style>
